/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router";
import { useHistory, Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import ImageGallery from "react-image-gallery";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Switch from "@material-ui/core/Switch";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import CustomInput from "components/CustomInput/CustomInput.js";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import LocalShipping from "@material-ui/icons/LocalShipping";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import HistoryIcon from '@mui/icons-material/History';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import RefreshIcon from '@mui/icons-material/Refresh';
import ApartmentIcon from '@mui/icons-material/Apartment';

import Favorite from "@material-ui/icons/Favorite";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Accordion from "components/Accordion/Accordion.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import NavPills from "components/NavPills/NavPills.js";
import EmailIcon from "@material-ui/icons/Email";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Icon from "@material-ui/core/Icon";
import Slide from "@material-ui/core/Slide";
import { FiPhoneCall } from "react-icons/fi";
import Popover from "@material-ui/core/Popover";
import { localApi, credentials, adminId, convertToNextTenth } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import SweetAlert from "react-bootstrap-sweetalert";
import CornerRibbon from "react-corner-ribbon";

import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import radio from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

import logo from "assets/img/examples/apple-insha-bangles-icon.png";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import { cardTitle } from "assets/jss/material-kit-pro-react.js";

const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};

const useStyles = makeStyles(productStyle);
const useStyle = makeStyles(radio);
const useStylPop = makeStyles(popOver);
const useStyleAlert = makeStyles(style);
const useSty = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function InshaProduct() {
  const [prodList, setProdList] = React.useState([]);
  const [item, setItem] = React.useState([]);
  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [otpNumber, setOtpNumber] = React.useState("");
  const [otpNumberErr, setOtpNumberErr] = React.useState("");
  const [otpScreen, setOtpScreen] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [cat, setCat] = React.useState("");
  const [catMM, setCatMM] = React.useState("");
  const [child, setChild] = React.useState("");
  const [plat, setPlat] = React.useState("");
  const [plating, setPlating] = React.useState("");
  const [metOption, setMetOption] = React.useState("");
  const [sets, setSets] = React.useState("");
  const [box, setBox] = React.useState("");
  const [packing, setPacking] = React.useState("");
  const [calculate, setCalculate] = React.useState("");
  const [labourList, setLobourList] = React.useState("");
  const [metal, setMetal] = React.useState("");
  const [selectedEnabled, setSelectedEnabled] = React.useState("a");
  const [anchorElTop, setAnchorElTop] = React.useState(null);
  const [size1x8, setSize1x8] = React.useState(0);
  const [size1x9, setSize1x9] = React.useState(0);
  const [size1x10, setSize1x10] = React.useState(0);
  const [size1x11, setSize1x11] = React.useState(0);
  const [size1x12, setSize1x12] = React.useState(0);
  const [size1x13, setSize1x13] = React.useState(0);
  const [size1x14, setSize1x14] = React.useState(0);
  const [size1x15, setSize1x15] = React.useState(0);
  const [size2x0, setSize2x0] = React.useState(0);
  const [size2x1, setSize2x1] = React.useState(0);
  const [size2x2, setSize2x2] = React.useState(0);
  const [size2x3, setSize2x3] = React.useState(0);
  const [size2x4, setSize2x4] = React.useState(0);
  const [size2x5, setSize2x5] = React.useState(0);
  const [size2x6, setSize2x6] = React.useState(0);
  const [size2x7, setSize2x7] = React.useState(0);
  const [size2x8, setSize2x8] = React.useState(0);
  const [size2x9, setSize2x9] = React.useState(0);
  const [size2x10, setSize2x10] = React.useState(0);
  const [size2x11, setSize2x11] = React.useState(0);
  const [size2x12, setSize2x12] = React.useState(0);
  const [size2x13, setSize2x13] = React.useState(0);
  const [size2x14, setSize2x14] = React.useState(0);
  const [size2x15, setSize2x15] = React.useState(0);
  const [size3x0, setSize3x0] = React.useState(0);
  const [size3x1, setSize3x1] = React.useState(0);
  const [comment, setComment] = React.useState(
    "Mix different four sizes in one design, or mix different six designs in one size, or one design in one size."
  );
  const [loginModal, setLoginModal] = React.useState(false);
  const [prodMix, setProdMix] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertMsg, alertMsgOps] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");
  const [proTotal, setProTotal] = React.useState("");

  const [reSend, setReSend] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [admin, setAdmin] = React.useState([]);
  const [register, setRegister] = React.useState("");
  const [registerClient, setRegisterClient] = React.useState("");
  const [imageGal, setImageGal] = React.useState([]);

  const [checkedFullSize, setCheckedFullSize] = React.useState(true);
  const [checkedCutSize, setCheckedCutSize] = React.useState(false);

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);

  const [emailConfirm, setEmailConfirm] = React.useState("");
  const [emailConfirmErr, setEmailConfirmErr] = React.useState("");

  const [otpMpin, setOtpMpin] = React.useState("");
  const [forgotPass, setForgotPass] = React.useState(false);
  const [otpConfirm, setOtpConfirm] = React.useState(false);
  const [updatePassword, setUpdatePassword] = React.useState(false);

  const [password, setPassword] = useState(["", "", "", "", "", ""]);
  const [passwordErr, setPasswordErr] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState(["", "", "", "", "", ""]);
  const [passwordConfirmErr, setPasswordConfirmErr] = useState("");
  const [updatePasswordConfirm, setUpdatePasswordConfirm] = useState(["", "", "", "", "", ""]);
  const [updatePasswordConfirmErr, setUpdatePasswordConfirmErr] = useState("");

  const [termsAccepted, setTermsAccepted] = React.useState(false);
  const [isVisibleReturn, setIsVisibleReturn] = React.useState(false);
  const [isVisibleRefund, setIsVisibleRefund] = React.useState(false);
  const [isVisibleExchange, setIsVisibleExchange] = React.useState(false);
  const [isVisibleDelivery, setIsVisibleDelivery] = React.useState(false);
  const [isVisibleCustomer, setIsVisibleCustomer] = React.useState(false);

  // ✅ Refs - separate for each section
  const inputs = useRef([]);          // Login / OTP input refs
  const inputsConfirm = useRef([]);   // Confirm Code input refs
  const inputsUpdate = useRef([]);    // Update mPIN input refs

  // Initialize refs only once
  useEffect(() => {
    inputs.current = Array(6)
      .fill()
      .map((_, i) => inputs.current[i] || React.createRef());
    inputsConfirm.current = Array(6)
      .fill()
      .map((_, i) => inputsConfirm.current[i] || React.createRef());
    inputsUpdate.current = Array(6)
      .fill()
      .map((_, i) => inputsUpdate.current[i] || React.createRef());
  }, []);

  const classes = useStyles();
  const classe = useStyle();
  const classPop = useStylPop();
  const history = useHistory();
  const classeAlert = useStyleAlert();
  // const classe = useStyl();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const search = useLocation().search;
  const catdesc = new URLSearchParams(search).get("catdesc");
  const cat1desc = new URLSearchParams(search).get("cat1desc");
  const id = new URLSearchParams(search).get("id");

  async function getProdSEO() {
    const results = await fetch(
      localApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }
    );
    const res = await results.json();

    // console.log(res.map((f) => f.state));
    setStateList(res.map((f) => f.state))

    axios.get(localApi + `/admin/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      setCompanyList(res.data.AdminList.map((f) => f.company))
    });

    axios.get(localApi + `/category/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      const items = res.data.map((f) => f.title);

      const uniqueItems = items.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );

      setCategoryList(uniqueItems);
    });

    axios.get(localApi + `/parent/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      const itemss = res.data.map((f) => f.title);

      const uniqueItemss = itemss.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );
      setParentList(uniqueItemss);
    });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  async function getProd() {
    // const get = headApi + `/products/byCatMM?catdesc="${catdesc}"&cat1desc="${cat1desc}"&userid=1&active=1`;
    const get =
      localApi +
      `/product/list/byCatMM?admin_id=${adminId}&active=1&catdesc=${catdesc}&cat1desc=${cat1desc}`;
    const results = await fetch(get, {
      method: "GET",

      headers: {
        Authorization: `Basic ${credentials}`,
      },

    });
    const res = await results.json();
    setProdList(res.filter((f) => f.id != id));
  }

  useEffect(() => {
    getProd();
  }, []);

  async function getAdmin() {
    const api = localApi + `/admin/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setAdmin(getResult.AdminList);
  }

  async function getRegister() {
    const api = localApi + `/register/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setRegister(getResult.ClientList);
  }

  async function getRegisterClient() {
    const api = localApi + `/clientGroup/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setRegisterClient(getResult.ClientList);
  }

  useEffect(() => {
    getAdmin();
    getRegister();
    getRegisterClient();
  }, []);

  // ✅ Password change handlers
  const handlePasswordChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...password];
      updated[index] = text;
      setPassword(updated);

      if (text && index < 5) {
        inputs.current[index + 1] && inputs.current[index + 1].focus();
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !password[index] && index > 0) {
      inputs.current[index - 1] && inputs.current[index - 1].focus();
    }
  };

  // ✅ Confirm Code handlers
  const handlePasswordChangeConfirm = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...passwordConfirm];
      updated[index] = text;
      setPasswordConfirm(updated);

      if (text && index < 5) {
        inputsConfirm.current[index + 1] && inputsConfirm.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirm = (e, index) => {
    if (e.key === "Backspace" && !passwordConfirm[index] && index > 0) {
      inputsConfirm.current[index - 1] && inputsConfirm.current[index - 1].focus();
    }
  };

  // ✅ Update Password handlers
  const handlePasswordChangeConfirmUpdate = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...updatePasswordConfirm];
      updated[index] = text;
      setUpdatePasswordConfirm(updated);

      if (text && index < 5) {
        inputsUpdate.current[index + 1] && inputsUpdate.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirmUpdate = (e, index) => {
    if (e.key === "Backspace" && !updatePasswordConfirm[index] && index > 0) {
      inputsUpdate.current[index - 1] && inputsUpdate.current[index - 1].focus();
    }
  };

  // const handleMobileNumber = (mobile) => {
  //   setMobile(mobile);
  //   // setMobileErr("");

  //   fetch(localApi + `/register/find/byMobile/${mobile}`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Basic ${credentials}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         // console.log(result);
  //         // setMobileErr(result.message);
  //         if (result.message === "Mobile No. Already Registered") {
  //           setMobileErr("");
  //         } else if (result.message === "Not Found") {
  //           setMobileErr("Your No. Not Registered");
  //         } else {
  //           setMobileErr(result.message);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  // };

  const PHONE_RULES = {
    in: 12,  // India 91 + 10
    us: 11,  // USA 1 + 10
    ca: 11,  // Canada
    mx: 12,  // Mexico
    br: 13,  // Brazil
    ar: 12,  // Argentina

    uk: 12,  // United Kingdom 44 + 10
    fr: 11,  // France
    de: 12,  // Germany
    it: 12,  // Italy
    es: 12,  // Spain
    nl: 11,  // Netherlands
    be: 11,  // Belgium
    ch: 11,  // Switzerland
    at: 11,  // Austria
    se: 11,  // Sweden
    no: 11,  // Norway
    dk: 10,  // Denmark
    fi: 11,  // Finland
    ie: 11,  // Ireland
    pt: 12,  // Portugal
    pl: 11,  // Poland
    cz: 12,  // Czech
    hu: 11,  // Hungary
    ro: 12,  // Romania
    bg: 12,  // Bulgaria
    gr: 12,  // Greece
    ru: 11,  // Russia
    ua: 12,  // Ukraine

    ae: 12,  // UAE 971 + 9
    sa: 12,  // Saudi Arabia
    qa: 11,  // Qatar
    kw: 11,  // Kuwait
    om: 11,  // Oman
    bh: 11,  // Bahrain
    jo: 12,  // Jordan
    lb: 11,  // Lebanon
    il: 12,  // Israel
    tr: 12,  // Turkey
    ir: 12,  // Iran
    iq: 13,  // Iraq

    cn: 13,  // China
    jp: 11,  // Japan
    kr: 11,  // South Korea
    sg: 10,  // Singapore
    my: 11,  // Malaysia
    th: 11,  // Thailand
    id: 12,  // Indonesia
    ph: 12,  // Philippines
    vn: 11,  // Vietnam
    hk: 11,  // Hong Kong
    tw: 11,  // Taiwan

    au: 11,  // Australia
    nz: 11,  // New Zealand

    za: 11,  // South Africa
    ng: 13,  // Nigeria
    ke: 12,  // Kenya
    eg: 12,  // Egypt
    ma: 12,  // Morocco
    gh: 12,  // Ghana
  };


  const handleMobileNumber = (mobile, country) => {
    setMobile(mobile);
    setMobileErr("");

    const rule = PHONE_RULES[country];

    // ❌ stop API calls for incomplete numbers
    if (!rule || mobile.length !== rule.totalLength) {
      return;
    }

    fetch(localApi + `/register/find/byMobile/${mobile}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then(async (res) => {
        if (res.status === 404) {
          setMobileErr("Your number is not registered");
          return null;
        }
        if (!res.ok) throw new Error("Server error");
        return res.json();
      })
      .then((result) => {
        if (!result) return;

        if (result.message === "Mobile No. Already Registered") {
          setMobileErr("");
        } else {
          setMobileErr(result.message);
        }
      })
      .catch(console.log);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  };

  const handleEmail = (e) => {
    const value = e.target.value.trim();
    setEmail(value);
    setEmailErr("");

    // 🔴 empty field
    if (!value) {
      setEmailErr("Email is required");
      return;
    }

    // 🔴 invalid format
    if (!isValidEmail(value)) {
      setEmailErr("Please enter a valid email address");
      return;
    }

    // ✅ only valid email reaches API
    fetch(`${localApi}/register/find/byEmail/${value}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then(async (res) => {
        if (res.status === 404) {
          setEmailErr("Your email is not registered");
          return null;
        }
        if (!res.ok) throw new Error("Server error");
        return res.json();
      })
      .then((result) => {
        if (!result) return;

        if (result.message === "Email ID Already Registered") {
          setEmailErr("");
        } else {
          setEmailErr(result.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleEmailConfirm = (e) => {
    const { value } = e.target;
    setEmailConfirm(value);

    // ❌ stop if empty
    if (!value) return;

    // ❌ stop if invalid email format
    if (!isValidEmail(value)) {
      setEmailConfirmErr("Please enter a valid email address");
      return;
    }

    if (value) {
      fetch(localApi + `/register/find/byEmail/${value}`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
        .then(async (res) => {
          // ✅ prevent 404 console error
          if (res.status === 404) {
            return { message: "Not Found" };
          }
          return res.json();
        })
        .then((result) => {
          // 🔁 SAME conditions as your original code
          if (result.message === "Email ID Already Registered") {
            setEmailConfirmErr("");
          } else if (result.message === "Not Found") {
            setEmailConfirmErr("Your Email Not Registered");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleOtp = (e) => {
    // console.log(e.target.value);
    setOtpNumber(e.target.value);
    setOtpNumberErr("");
  };

  const handleSendOtpWithMobile = async () => {
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in"
    );
    const api = localApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
        `/otp/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("OTP")
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendPasswordWithMobile = async () => {
    // console.log("okkkk");
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in"
    );
    const api = localApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
        `/register/password/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("mPIN")
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendOtpWithEmail = async () => {
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in"
    );
    const api = localApi + `/register/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        to: email,
        subject: "API CREATION SUBJECT",
        websitename: "indianbangles.in",
        followId: getFindAdmin.id,
        adminId: getResult.aId,
      }),
    };
    fetch(
      localApi + `/otp/send/byEmail?e=noreply@indianbangles.in`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        setEmailErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
          setOtpMpin("OTP")
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginWithMobile = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (passwordString === "" || !passwordString || passwordString.length !== 6) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
        `/register/recieved/byMobile?mobile=${mobile}&otp=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },

        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            setLoginModal(false);
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithMobilePassword = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (passwordString === "" || !passwordString || passwordString.length !== 6) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
        `/register/recieved/byMobilePassword?mobile=${mobile}&password=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },

        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            setLoginModal(false);
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  const handleLoginWithEmail = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (passwordString === "" || !passwordString || passwordString.length !== 6) {
      errorCount++;
      setOtpNumberErr("Enter Otp Number");
    }
    if (errorCount === 0) {
      fetch(
        localApi + `/register/recieved/byEmail?email=${email}&otp=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },

        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            setLoginModal(false);
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  async function productGet() {
    const get = localApi + `/product/findById/${id}`;
    const result = await fetch(get, {
      method: "GET",

      headers: {
        Authorization: `Basic ${credentials}`,
      },

    });
    const rest = await result.json();
    setImageGal(
      rest.productimage.map((c) => {
        return {
          original: c.cpanelPath,
          thumbnail: c.cpanelPath,
        };
      })
    );
    // const MixId = rest.mixmm ? rest.mixmm.split(",") : "";
    // const tempData = [];
    // MixId && MixId.forEach(x =>
    //   axios.get(localApi + `/product/findById/${x}`)
    //     .then(res => {
    //       // console.log(res.data);
    //       tempData.push(res.data);
    //     }))
    // setProdMix(tempData);

    // console.log(rest);

    let resultChild = "";   // initialize empty string

    rest.productchild.forEach((item) => {
      let line = item.title.trim();

      if (line.includes("Plating")) {
        // Remove [ ] brackets
        line = line.replace(/\[/g, "").replace(/\]/g, "").trim();

        // Extract only text AFTER "Plating"
        const afterPlating = line
          .substring(line.indexOf("Plating") + "Plating".length)
          .trim();

        // Clean again
        const cleanText = afterPlating
          .replace(/\[/g, "")
          .replace(/\]/g, "")
          .trim();

        // Add to final string
        resultChild += cleanText + " ";
      }
    });

    // console.log("Plating Result:", resultChild.trim());

    setItem(rest);
    setCat(rest.category);
    setCatMM(rest.parent);
    setChild(resultChild.trim());
    // setPlat(rest.plating);
    // setPlating(rest.plating.description);
    // setMetOption(rest.metalOption);
    setSets(rest.sets);
    setBox(rest.box);
    setPacking(rest.packingMaterial);
    // setCalculate(rest.taxCalculation);
    setLobourList(rest.productchild);
    setMetal(rest.rawPrice);
    setProTotal(rest.stockSize.length);
    // console.log(rest.stockSize[0]);

    if (rest.stockSize[0] && rest.stockSize[0].cutOrFullSize == 3) {
      setCheckedFullSize(true);
      setCheckedCutSize(true);
    }
    if (rest.stockSize[0] && rest.stockSize[0].cutOrFullSize == 1) {
      setCheckedFullSize(true);
    }
    if (rest.stockSize[0] && rest.stockSize[0].cutOrFullSize == 2) {
      setCheckedCutSize(true);
    }

    setSize1x8(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x8 : "0"
    );
    setSize1x9(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x9 : "0"
    );
    setSize1x10(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x10 : "0"
    );
    setSize1x11(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x11 : "0"
    );
    setSize1x12(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x12 : "0"
    );
    setSize1x13(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x13 : "0"
    );
    setSize1x14(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x14 : "0"
    );
    setSize1x15(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s1x15 : "0"
    );
    setSize2x0(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x0 : "0"
    );
    setSize2x1(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x1 : "0"
    );
    setSize2x2(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x2 : "0"
    );
    setSize2x3(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x3 : "0"
    );
    setSize2x4(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x4 : "0"
    );
    setSize2x5(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x5 : "0"
    );
    setSize2x6(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x6 : "0"
    );
    setSize2x7(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x7 : "0"
    );
    setSize2x8(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x8 : "0"
    );
    setSize2x9(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x9 : "0"
    );
    setSize2x10(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x10 : "0"
    );
    setSize2x11(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x11 : "0"
    );
    setSize2x12(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x12 : "0"
    );
    setSize2x13(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x13 : "0"
    );
    setSize2x14(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x14 : "0"
    );
    setSize2x15(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s2x15 : "0"
    );
    setSize3x0(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s3x0 : "0"
    );
    setSize3x1(
      rest.stockSize[0] && rest.stockSize[0] ? rest.stockSize[0].s3x1 : "0"
    );
  }

  useEffect(() => {
    productGet();
    setLoginModal(true);
  }, []);

  // const totalPiece = Math.ceil("864" / sets.pcs / box.box);
  const totalPiece =
    checkedFullSize === true
      ? checkedCutSize === true
        ? Math.floor(item.moq / 2 / 6)
        : checkedFullSize === true
          ? Math.floor(item.moq / 1 / 6)
          : "0"
      : checkedCutSize === true
        ? Math.floor(item.moq / 1 / 6)
        : "0";

  // const images = [];
  // const imgActive = [];
  // let val = 1;
  // Object.keys(item).map((i) => {
  //   if (i.includes("design")) {
  //     images.push({
  //       original:
  //         item[i][`image${val}`] !==
  //         "https://www.secure.mybangles24.com/crop_img/null"
  //           ? item[i][`image${val}`]
  //           : "",
  //       thumbnail:
  //         item[i][`image${val}`] !==
  //         "https://www.secure.mybangles24.com/crop_img/null"
  //           ? item[i][`image${val}`]
  //           : "",
  //     });
  //     imgActive.push({ active: item[i][`img${val}active`] });
  //     val += 1;
  //   }
  // });

  // const images = [];
  // const imgActive = [];
  // let val = 1;
  // Object.keys(item).map((i) => {
  //   if (i.includes("design")) {
  //     // console.log(item[i][`image${val}`]);
  //     images.push({
  //       original:
  //         imgApi + "" + item[i][`image${val}`] !==
  //           imgApi + "" + "/crop_img/null"
  //           ? imgApi + "" + item[i][`image${val}`]
  //           : "",
  //       thumbnail:
  //         imgApi + "" + item[i][`image${val}`] !==
  //           imgApi + "" + "/crop_img/null"
  //           ? imgApi + "" + item[i][`image${val}`]
  //           : "",
  //     });
  //     imgActive.push({ active: item[i][`img${val}active`] })
  //     val += 1;
  //   }
  // });

  var indianQty =
    parseInt(size1x8) +
    parseInt(size1x10) +
    parseInt(size1x12) +
    parseInt(size1x14) +
    parseInt(size2x0) +
    parseInt(size2x2) +
    parseInt(size2x4) +
    parseInt(size2x6) +
    parseInt(size2x8) +
    parseInt(size2x10) +
    parseInt(size2x12) +
    parseInt(size2x14) +
    parseInt(size3x0);

  var usQty =
    parseInt(size1x9) +
    parseInt(size1x11) +
    parseInt(size1x13) +
    parseInt(size1x15) +
    parseInt(size2x1) +
    parseInt(size2x3) +
    parseInt(size2x5) +
    parseInt(size2x7) +
    parseInt(size2x9) +
    parseInt(size2x11) +
    parseInt(size2x13) +
    parseInt(size2x15) +
    parseInt(size3x1);

  const cardValInd = item.moq - indianQty;
  const cardValUs = item.moq - usQty;

  const FullAndCutSizeTotal = item.moq - (indianQty + usQty);

  setTimeout(() => {
    setAnchorElTop(null);
  }, 4000);

  const handleAddCart = () => {
    const getFindRegister = register?.find((f) => f.id === userObj.id);
    const getFindAdmin = admin?.find((f) => f.id === getFindRegister.aId);
    const getRegisterClient = registerClient?.find(
      (f) => f.regId === userObj.id
    );

    const cgstTax =
      item.gstCash === true
        ? getFindAdmin.state === getFindRegister.state
          ? item.cgst
          : "0"
        : getFindAdmin.state === getFindRegister.state
          ? item.cgst
          : "0";

    const sgstTax =
      item.gstCash === true
        ? getFindAdmin.state === getFindRegister.state
          ? item.sgst
          : "0"
        : getFindAdmin.state === getFindRegister.state
          ? item.sgst
          : "0";

    const igstTax =
      item.gstCash === true
        ? getFindAdmin.state === getFindRegister.state
          ? "0"
          : item.igst
        : getFindAdmin.state === getFindRegister.state
          ? "0"
          : item.igst;

    var per = 100.0;
    var cTax = cgstTax;
    var sTax = sgstTax;
    var iTax = igstTax;
    var localPer = parseFloat(per) + parseFloat(cTax) + parseFloat(sTax);
    var interestedPer = parseFloat(per) + parseFloat(iTax);
    var local = parseFloat(cTax) + parseFloat(sTax);
    var interested = parseFloat(iTax);
    const totalCtnAmt = item.ctnPackCharge * item.ctnQuantity;


    const requestOptions = {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        firstName: userObj.firstname,
        lastName: userObj.lastname,
        company: userObj.company,
        metalGram: item.metalGram,
        extraGram: item.extraGram,
        readyGram: item.readyGram,
        hsnSacCode: item.hsnSacCode,
        golwireThaw: item.golwireThaw,
        itemCodeNumber: item.itemCodeNumber,
        prodManfDetails: item.prodManfDetails,
        prodDescription: item.prodDescription,
        cartDescription: item.ctnDescription,
        cartQuantity: item.ctnQuantity,
        cartPackCharge: item.ctnPackCharge,
        active: false,
        gstCash: item.gstCash,
        comment: comment,
        hsnSacCode: item.hsnSacCode,
        crmReferenceId: null,
        cartChild: item.productchild.map((c) => {
          return {
            lbrId: c.lbrId,
            price: c.price,
            taxPercentage: c.taxPercentage,
            hsncode: c.hsncode,
            title: c.title,
            parentId: item.parent.id,
          };
        }),
        cartImage: item.productimage.map((ch) => {
          return {
            imgId: ch.imgId,
            categoryId: item.category.id,
            parentId: item.parent.id,
            cropImageUrl: ch.cropImageUrl,
            cropName: ch.cropName,
          };
        }),
        taxApply: item.gstCash === true ? true : false,
        saleType: getFindAdmin.state === getFindRegister.state ? "0" : "1",
        cgst:
          item.gstCash === true
            ? getFindAdmin.state === getFindRegister.state
              ? item.cgst
              : "0"
            : getFindAdmin.state === getFindRegister.state
              ? item.cgst
              : "0",
        sgst:
          item.gstCash === true
            ? getFindAdmin.state === getFindRegister.state
              ? item.sgst
              : "0"
            : getFindAdmin.state === getFindRegister.state
              ? item.sgst
              : "0",
        igst:
          item.gstCash === true
            ? getFindAdmin.state === getFindRegister.state
              ? "0"
              : item.igst
            : getFindAdmin.state === getFindRegister.state
              ? "0"
              : item.igst,
        cutOrFullSize:
          checkedFullSize === true
            ? checkedCutSize === true
              ? "3"
              : checkedFullSize === true
                ? "1"
                : "0"
            : checkedCutSize === true
              ? "2"
              : "0",
        countrySize: "",
        size1x8: size1x8 ? size1x8 : 0,
        size1x9: size1x9 ? size1x9 : 0,
        size1x10: size1x10 ? size1x10 : 0,
        size1x11: size1x11 ? size1x11 : 0,
        size1x12: size1x12 ? size1x12 : 0,
        size1x13: size1x13 ? size1x13 : 0,
        size1x14: size1x14 ? size1x14 : 0,
        size1x15: size1x15 ? size1x15 : 0,
        size2x0: size2x0 ? size2x0 : 0,
        size2x1: size2x1 ? size2x1 : 0,
        size2x2: size2x2 ? size2x2 : 0,
        size2x3: size2x3 ? size2x3 : 0,
        size2x4: size2x4 ? size2x4 : 0,
        size2x5: size2x5 ? size2x5 : 0,
        size2x6: size2x6 ? size2x6 : 0,
        size2x7: size2x7 ? size2x7 : 0,
        size2x8: size2x8 ? size2x8 : 0,
        size2x9: size2x9 ? size2x9 : 0,
        size2x10: size2x10 ? size2x10 : 0,
        size2x11: size2x11 ? size2x11 : 0,
        size2x12: size2x12 ? size2x12 : 0,
        size2x13: size2x13 ? size2x13 : 0,
        size2x14: size2x14 ? size2x14 : 0,
        size2x15: size2x15 ? size2x15 : 0,
        size3x0: size3x0 ? size3x0 : 0,
        size3x1: size3x1 ? size3x1 : 0,
        categoryId: item.category.id,
        categoryTitle: item.category.title,
        parentId: item.parent.id,
        parentTitle: item.parent.title,
        setsPcs: item.sets.pcs,
        setsDesc: item.sets.setDesc,
        setsId: item.sets.id,
        rawId: item.rawPrice.id,
        rawTitle: item.rawPrice.title,
        rawPrice: item.rawPrice.price,
        rawDifferent: item.rawPrice.different,
        rawTax: item.rawPrice.tax,
        rawTaxPercentage: item.rawPrice.taxPercentage,
        boxId: item.box.id,
        boxBrandName: item.box.brandName,
        boxDesc: item.box.boxDesc,
        boxPkgCharge: item.box.pkgCharge,
        box: item.box.box,
        boxHsnCode: item.box.hsnCode,
        boxPrice: item.box.price,
        boxTaxPercentage: item.box.tax_percentage,
        packingId: item.packingMaterial.id,
        packingType: item.packingMaterial.type,
        packingDesc: item.packingMaterial.pkgdesc,
        packingHsncode: item.packingMaterial.hsncode,
        packingPrice: item.packingMaterial.price,
        packingLigst: item.packingMaterial.ligst,
        boxUnit: "BOX",
        ctnUnit: "BOX",
        taxAbleAmount:
          item.gstCash === true
            ? ((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
              (getFindAdmin.state === getFindRegister.state
                ? localPer
                : interestedPer)) *
            100
            : 0,
        taxCgst:
          item.gstCash === true
            ? item.taxApply === false
              ? 0
              : item.taxApply === true
                ? getFindAdmin.state === getFindRegister.state
                  ? (((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
                    (getFindAdmin.state === getFindRegister.state
                      ? localPer
                      : interestedPer)) *
                    (getFindAdmin.state === getFindRegister.state
                      ? local
                      : interested)) /
                    2
                    ? (((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
                      (getFindAdmin.state === getFindRegister.state
                        ? localPer
                        : interestedPer)) *
                      (getFindAdmin.state === getFindRegister.state
                        ? local
                        : interested)) /
                    2
                    : 0
                  : 0
                : 0
            : 0,
        taxSgst:
          item.gstCash === true
            ? item.taxApply === false
              ? 0
              : item.taxApply === true
                ? getFindAdmin.state === getFindRegister.state
                  ? (((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
                    (getFindAdmin.state === getFindRegister.state
                      ? localPer
                      : interestedPer)) *
                    (getFindAdmin.state === getFindRegister.state
                      ? local
                      : interested)) /
                    2
                    ? (((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
                      (getFindAdmin.state === getFindRegister.state
                        ? localPer
                        : interestedPer)) *
                      (getFindAdmin.state === getFindRegister.state
                        ? local
                        : interested)) /
                    2
                    : 0
                  : 0
                : 0
            : 0,
        taxIgst:
          item.gstCash === true
            ? item.taxApply === false
              ? 0
              : item.taxApply === true
                ? getFindAdmin.state !== getFindRegister.state
                  ? ((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
                    (getFindAdmin.state !== getFindRegister.state
                      ? interestedPer
                      : localPer)) *
                    (getFindAdmin.state === getFindRegister.state
                      ? local
                      : interested)
                    ? ((item.taxInclude * (indianQty + usQty) + totalCtnAmt) /
                      (getFindAdmin.state !== getFindRegister.state
                        ? interestedPer
                        : localPer)) *
                    (getFindAdmin.state === getFindRegister.state
                      ? local
                      : interested)
                    : 0
                  : 0
                : 0
            : 0,
        taxTotal:
          item.gstCash === true
            ? getFindAdmin.state === getFindRegister.state
              ? ((((item.gstCash === true ? item.taxInclude : "0") *
                (indianQty + usQty) + totalCtnAmt) /
                (getFindAdmin.state === getFindRegister.state
                  ? localPer
                  : interestedPer)) *
                (getFindAdmin.state === getFindRegister.state
                  ? local
                  : interested)) /
              2 +
              ((((item.gstCash === true ? item.taxInclude : "0") *
                (indianQty + usQty) + totalCtnAmt) /
                (getFindAdmin.state === getFindRegister.state
                  ? localPer
                  : interestedPer)) *
                (getFindAdmin.state === getFindRegister.state
                  ? local
                  : interested)) /
              2
              : (((item.gstCash === true ? item.taxInclude : "0") *
                (indianQty + usQty) + totalCtnAmt) /
                (getFindAdmin.state === getFindRegister.state
                  ? localPer
                  : interestedPer)) *
              (getFindAdmin.state === getFindRegister.state
                ? local
                : interested)
            : 0,
        taxType:
          item.gstCash === true ? getFindAdmin.state === getFindRegister.state ? item.cgst : item.igst : 0,
        stock: false,
        sizeTotal: indianQty + usQty,
      }),
    };

    fetch(
      localApi +
      `/cart/add/${getFindAdmin.id}/${item.id}/${getRegisterClient.id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        if (data.message === "Data Inserted Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Successfully");
          setSubmitted(true);
        }
      });
  };

  const hideAlert = () => {
    setSubmitted(false);
    // window.location.reload(false);
    history.push("/add-cart");
  };

  const inputDigit = {
    width: "40px",
    height: "40px",
    fontSize: "20px",
    textAlign: "center",
    borderRadius: "8px",
    border: "1px solid #ccc",
  };

  const containerDigit = {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "20px",
    // marginLeft: "25px"
  };

  return (
    <div className={classes.productPage}>
      <Helmet>
        <html lang="en" />

        <title>
          {item?.prodDescription
            ? `${item.prodDescription} | INDIAN BANGLES`
            : "Bangles Product | INDIAN BANGLES"}
        </title>

        <meta
          name="description"
          content={
            item?.cartDescription ||
            "Buy premium imitation jewellery and bangles from INDIAN BANGLES at best price."
          }
        />

        <meta
          name="keywords"
          content={`${item?.prodDescription || "bangles"}, imitation jewellery, gold plated bangles, wholesale bangles`}
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href={`https://indianbangles.in/indian-product?id=${id}&catdesc=${catdesc}&cat1desc=${cat1desc}`}
        />

        {/* Open Graph */}
        <meta property="og:type" content="product" />
        <meta
          property="og:title"
          content={item?.prodDescription || "Bangles Product"}
        />
        <meta
          property="og:description"
          content={item?.cartDescription || ""}
        />
        <meta
          property="og:url"
          content={`https://indianbangles.in/indian-product?id=${id}&catdesc=${catdesc}&cat1desc=${cat1desc}`}
        />
        <meta
          property="og:image"
          content={
            item?.productImage?.[0]?.cropImageUrl || ""
          }
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={item?.prodDescription || "Bangles Product"}
        />
        <meta
          name="twitter:description"
          content={item?.cartDescription || ""}
        />
        <meta
          name="twitter:image"
          content={
            item?.productImage?.[0]?.cropImageUrl || ""
          }
        />

        {/* Product Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: item?.prodDescription,
            image: item?.productImage?.map(i => i.cropImageUrl),
            sku: item?.id,
            brand: {
              "@type": "Brand",
              name: "INDIAN BANGLES",
            },
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: item?.cashPrice,
              availability: "https://schema.org/InStock",
              url: `https://indianbangles.in/indian-product?id=${id}&catdesc=${catdesc}&cat1desc=${cat1desc}`,
            },
          })}
        </script>
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 100,
          color: "dark",
        }}
      />
      <Parallax
        image={require("assets/img/bg6.jpg").default}
        filter="dark"
        className={classes.pageHeader}
      ></Parallax>
      <div className={classNames(classes.section, classes.sectionGray)}>
        <div className={classes.container}>
          {submitted ? (
            <SweetAlert
              type={alertType}
              style={{ display: "block", marginTop: "100px" }}
              title={alertMsg}
              onConfirm={() => hideAlert()}
              confirmBtnCssClass={
                classeAlert.button + " " + classeAlert.success
              }
            >
              added to the cart!!
            </SweetAlert>
          ) : null}
          <div className={classNames(classes.main, classes.mainRaised)}>
            {!activeSession ? (
              <GridItem xs={12} sm={6} md={6} lg={6}>
                <Dialog
                  classes={{
                    root: classPop.modalRoot,
                    paper: classPop.modal + " " + classPop.modalLogin,
                  }}
                  open={loginModal}
                  TransitionComponent={Transition}
                  keepMounted
                  // onClose={() => setLoginModal(false)}
                  aria-labelledby="login-modal-slide-title"
                  aria-describedby="login-modal-slide-description"
                >
                  <Card plain className={classPop.modalLoginCard}>
                    <DialogTitle
                      id="login-modal-slide-title"
                      disableTypography
                      className={classPop.modalHeader}
                    >
                      <CardHeader
                        plain
                        color="rose"
                        className={
                          classPop.textCenter + " " + classPop.cardLoginHeader
                        }
                      >
                        <Button
                          simple
                          className={classPop.modalCloseButton}
                          key="close"
                          aria-label="Close"
                          onClick={() => {
                            setLoginModal(false);
                            history.push(
                              `/size-mm-list?catdesc=${catdesc}&cat1desc=${cat1desc}&Plating=Gold%20Plating`
                            );
                          }}
                        >
                          {" "}
                          <Close className={classPop.modalClose} />
                        </Button>
                        <h5 className={classPop.cardTitleWhite}>Log in</h5>
                      </CardHeader>
                    </DialogTitle>
                    <DialogContent
                      id="login-modal-slide-description"
                      className={classPop.modalBody}
                    >
                      {!otpScreen ? (
                        <form>
                          <p
                            className={
                              classPop.description + " " + classPop.textCenter
                            }
                          >
                            Welcome
                          </p>
                          <CardBody className={classPop.cardLoginBody}>
                            <GridContainer justify="center">
                              {/* <GridItem xs={12} sm={12} md={12}> */}
                              <NavPills
                                color="rose"
                                alignCenter
                                tabs={[
                                  {
                                    tabButton: "Mobile",
                                    tabIcon: PhoneAndroidIcon,
                                    tabContent: (
                                      <>
                                        {/* <CardBody> */}
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                            <PhoneInput
                                              inputStyle={{
                                                width: "100%",
                                                border: "none",
                                                borderBottom:
                                                  "1px solid #040000 ",
                                                borderRadius: "0",
                                              }}
                                              country={"in"}
                                              name="mobile"
                                              value={mobile}
                                              // onChange={(mobile) => {
                                              //   handleMobileNumber(mobile);
                                              // }}
                                              onChange={(value, country) => {
                                                handleMobileNumber(value, country?.countryCode);
                                              }}
                                              required={true}
                                            />
                                            <span style={{ color: "red" }}>
                                              {mobileErr}
                                            </span>
                                          </GridItem>
                                          {/* <Button
                                            color="rose"
                                            simple
                                            // size="lg"
                                            block
                                            onClick={handleSendOtpWithMobile}
                                          >
                                            Login
                                          </Button> */}
                                        </GridContainer>
                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                          <Button
                                            color="rose"
                                            onClick={handleSendOtpWithMobile}
                                            style={{ flex: 1, width: 50 }}
                                          >
                                            Continue via OTP
                                          </Button>

                                          <Button
                                            color="rose"
                                            onClick={handleSendPasswordWithMobile}
                                            style={{ flex: 1, width: 50 }}
                                          >
                                            Continue via mPIN
                                          </Button>
                                        </div>
                                        {/* </CardBody> */}
                                        {/* <CardFooter
                                          className={
                                            classe.justifyContentCenter
                                          }
                                        >
                                          <Button
                                            color="rose"
                                            simple
                                            // size="lg"
                                            block
                                            onClick={handleSendOtpWithMobile}
                                          >
                                            Login
                                          </Button>
                                        </CardFooter> */}
                                      </>
                                    ),
                                  },
                                  {
                                    tabButton: "Email",
                                    tabIcon: EmailIcon,
                                    tabContent: (
                                      <>
                                        {/* <CardBody> */}
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                              formControlProps={{
                                                fullWidth: true,
                                                className:
                                                  classes.customFormControlClasses,
                                              }}
                                              inputProps={{
                                                onChange: (e) => handleEmail(e),
                                                id: "email",
                                                value: email,
                                                name: "email",
                                                placeholder: "Email...",
                                              }}
                                              required={true}
                                            />
                                            <span style={{ color: "red" }}>
                                              {emailErr}
                                            </span>
                                          </GridItem>
                                          <Button
                                            color="rose"
                                            simple
                                            // size="lg"
                                            block
                                            onClick={handleSendOtpWithEmail}
                                          >
                                            Login
                                          </Button>
                                        </GridContainer>
                                        {/* </CardBody> */}
                                        {/* <CardFooter
                                          className={
                                            classe.justifyContentCenter
                                          }
                                        >
                                          <Button
                                            color="rose"
                                            simple
                                            // size="lg"
                                            block
                                            onClick={handleSendOtpWithEmail}
                                          >
                                            Login
                                          </Button>
                                        </CardFooter> */}
                                      </>
                                    ),
                                  },
                                ]}
                              />
                              {/* </GridItem> */}
                            </GridContainer>
                          </CardBody>
                          <br />
                          <div className={classes.textCenter}>
                            <h6>
                              Already have an account log in to Existing account
                            </h6>
                            <Button
                              simple
                              color="rose"
                              // size="lg"
                              href="/indian-register"
                            >
                              Create New Account
                            </Button>
                          </div>
                        </form>
                      ) : (
                        <form>
                          {!forgotPass && !otpConfirm && !updatePassword && (<>
                            <p
                              className={classPop.description + " " + classPop.textCenter}
                              style={{ marginLeft: "10px", marginRight: "10px" }}
                            >
                              6 digit {otpMpin} sent on your {mobile ? "Mobile" : "Email"}
                              <br />{mobile ? mobile : email}
                              {/* <br />{otp} {reSend} */}
                            </p>
                            <CardBody className={classPop.cardLoginBody}>
                              <div style={containerDigit}>
                                {password.map((digit, index) => (
                                  <input
                                    key={index}
                                    ref={(el) => (inputs.current[index] = el)}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => {
                                      handlePasswordChange(e.target.value, index);
                                      setPasswordErr("");
                                    }}
                                    onKeyDown={(e) => handleKeyPress(e, index)}
                                    style={inputDigit}
                                  />
                                ))}

                              </div>
                              <p
                                className={classes.description + " " + classes.textCenter}
                                style={{ color: "red" }}
                              >
                                {otpNumberErr}
                              </p>
                            </CardBody>
                            <div style={{
                              textAlign: "center", // centers inline content
                              display: "flex",     // makes children flex items
                              justifyContent: "center", // horizontal center
                              alignItems: "center",     // vertical center if needed
                              gap: "10px"               // spacing between elements
                            }}>
                              <Button
                                simple
                                color="rose"
                                // size="lg"
                                onClick={
                                  mobile ? otpMpin === "OTP" ? handleLoginWithMobile : handleLoginWithMobilePassword : handleLoginWithEmail
                                }
                              >
                                Log in
                              </Button>
                              <Button
                                simple
                                color="rose"
                              // size="lg"
                              // onClick={handleCall}
                              >
                                <FiPhoneCall /> Call Me
                              </Button>
                            </div>

                            <p className={classes.description} style={{
                              textAlign: "center", // centers inline content
                              display: "flex",     // makes children flex items
                              justifyContent: "center", // horizontal center
                              alignItems: "center",     // vertical center if needed
                              gap: "10px"               // spacing between elements
                            }}>
                              {otpMpin === "OTP" ? <>
                                Didn{"'"}t receive the OTP yet?{" "}
                                <span style={{ marginLeft: "10px" }}>
                                  <a
                                    // href="#"
                                    onClick={
                                      mobile
                                        ? handleSendOtpWithMobile
                                        : handleSendOtpWithEmail
                                    }
                                  >
                                    Resend OTP
                                  </a>
                                </span> </> : email ? "" : <Button
                                  color="transparent"
                                  style={{ textTransform: "none", textDecoration: "underline", color: "red" }}
                                  onClick={() => setForgotPass((prev) => !prev)}
                                >
                                  Forgot Password?
                                </Button>}
                            </p>
                          </>)}

                          {/* EMAIL CONFIRM SECTION */}
                          {forgotPass && (
                            <CardBody style={{ textAlign: "center" }}>
                              <h5 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Email Confirm
                              </h5>
                              <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Enter Your Email
                              </h6>
                              <CustomInput
                                formControlProps={{
                                  fullWidth: true,
                                  className:
                                    classes.customFormControlClasses,
                                }}
                                inputProps={{
                                  onChange: (e) => handleEmailConfirm(e),
                                  id: "emailConfirm",
                                  value: emailConfirm,
                                  name: "emailConfirm",
                                  placeholder: "Email...",
                                }}
                                required={true}
                              />
                              <span style={{ color: "red" }}>{emailConfirmErr}</span>
                              <br />

                              <Button
                                color="transparent"
                                style={{
                                  textTransform: "none",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "red",
                                }}
                                onClick={async () => {

                                  const getFindAdmin = admin?.find(
                                    (f) => f.websitename === "indianbangles.in"
                                  );
                                  const api = localApi + `/register/byEmail/${emailConfirm}`;
                                  const result = await fetch(api, {
                                    method: "GET",
                                    headers: {
                                      Authorization: `Basic ${credentials}`,
                                    },
                                  });
                                  const getResult = await result.json();
                                  fetch(
                                    localApi + `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                                    {
                                      method: "POST",
                                      headers: {
                                        "content-type": "application/json",
                                        accept: "application/json",
                                        Authorization: `Basic ${credentials}`,
                                      },
                                      body: JSON.stringify({
                                        to: emailConfirm,
                                        subject: "API CREATION SUBJECT",
                                        websitename: "indianbangles.in",
                                        followId: getFindAdmin.id,
                                        adminId: getResult.aId,
                                      }),
                                    }

                                  )
                                    .then((response) => response.json())
                                    .then((res) => {
                                      // console.log(res);

                                      if (res.message === "OTP Sent On Your Email ID Successfully") {
                                        // ✅ Close forgotPass when OTP is confirmed
                                        setOtpConfirm(true);
                                        setForgotPass(false);
                                      } else if (res.message === "Your Email And Mobile not Match ") {
                                        setEmailConfirmErr("Email & Mobile Not Match");
                                      }
                                      // "Sender Not Found to +919967457786"
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                }}
                              >
                                Confirm Email
                              </Button>
                            </CardBody>
                          )}

                          {/* OTP CONFIRM SECTION */}
                          {otpConfirm && (
                            <CardBody style={{ textAlign: "center" }}>
                              <h5 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Enter Verification Code
                              </h5>
                              <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                For your Security we have sent the Code to your Email<br />
                                {emailConfirm}
                              </h6>
                              <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Enter your 6-digit Code
                              </h6>

                              <div style={containerDigit}>
                                {passwordConfirm.map((digit, index) => (
                                  <input
                                    key={index}
                                    ref={(el) => (inputsConfirm.current[index] = el)}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => {
                                      handlePasswordChangeConfirm(e.target.value, index);
                                      setPasswordConfirmErr("");
                                    }}
                                    onKeyDown={(e) => handleKeyPressConfirm(e, index)}
                                    style={inputDigit}
                                  />
                                ))}

                              </div>

                              <span style={{ color: "red" }}>{passwordConfirmErr}</span>
                              <br />

                              <Button
                                color="transparent"
                                style={{
                                  textTransform: "none",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "red",
                                }}
                                onClick={() => {
                                  const password = passwordConfirm.join("");

                                  if (password.length !== 6) {
                                    setPasswordConfirmErr("mPIN must be exactly 6 digits.");
                                    return;
                                  }

                                  fetch(
                                    `${localApi}/register/recieved/byEmailAndMobile?email=${emailConfirm}&mobile=${mobile}&otp=${password}`,
                                    {
                                      method: "PUT",
                                      headers: { Authorization: `Basic ${credentials}` },
                                    }
                                  )
                                    .then((response) => response.json())
                                    .then((response) => {
                                      setPasswordConfirmErr(response.message);
                                      if (response.message === "Your Mobile And Email ID Match !!!") {
                                        setUpdatePassword(true);
                                        setOtpConfirm(false);
                                      }
                                    })
                                    .catch((err) => console.log(err));
                                }}
                              >
                                Confirm Code
                              </Button>
                              <br />

                              <Button
                                color="transparent"
                                style={{
                                  textTransform: "none",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "red",
                                }}
                                onClick={async () => {

                                  const getFindAdmin = admin?.find(
                                    (f) => f.websitename === "indianbangles.in"
                                  );
                                  const api = localApi + `/register/byEmail/${emailConfirm}`;
                                  const result = await fetch(api, {
                                    method: "GET",
                                    headers: {
                                      Authorization: `Basic ${credentials}`,
                                    },
                                  });
                                  const getResult = await result.json();
                                  fetch(
                                    localApi + `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                                    {
                                      method: "POST",
                                      headers: {
                                        "content-type": "application/json",
                                        accept: "application/json",
                                        Authorization: `Basic ${credentials}`,
                                      },
                                      body: JSON.stringify({
                                        to: emailConfirm,
                                        subject: "API CREATION SUBJECT",
                                        websitename: "indianbangles.in",
                                        followId: getFindAdmin.id,
                                        adminId: getResult.aId,
                                      }),
                                    }

                                  )
                                    .then((response) => response.json())
                                    .then((res) => {
                                      //  console.log(res);

                                      if (res && res.message === "OTP Sent On Your Email ID Successfully") {
                                        setEmailConfirmErr("OTP Resend On Your Email ID");
                                      }
                                      // "Sender Not Found to +919967457786"
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                }}
                              >
                                Didn't receive the Code yet? <br /> Resend Code
                              </Button>
                            </CardBody>
                          )}

                          {/* UPDATE PASSWORD SECTION */}
                          {updatePassword && (
                            <CardBody style={{ textAlign: "center" }}>
                              <h5 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Forgot mPIN
                              </h5>
                              <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Enter New 6-digit mPIN
                              </h6>

                              <div style={containerDigit}>
                                {updatePasswordConfirm.map((digit, index) => (
                                  <input
                                    key={index}
                                    ref={(el) => (inputsUpdate.current[index] = el)}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => {
                                      handlePasswordChangeConfirmUpdate(e.target.value, index);
                                      setUpdatePasswordConfirmErr("");
                                    }}
                                    onKeyDown={(e) => handleKeyPressConfirmUpdate(e, index)}
                                    style={inputDigit}
                                  />
                                ))}

                              </div>

                              <span style={{ color: "red" }}>{updatePasswordConfirmErr}</span>
                              <br />

                              <Button
                                color="transparent"
                                style={{
                                  textTransform: "none",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "red",
                                }}
                                onClick={async () => {
                                  const password = updatePasswordConfirm.join("");

                                  if (password.length !== 6) {
                                    setUpdatePasswordConfirmErr("mPIN must be exactly 6 digits.");
                                    return;
                                  }

                                  const requestOptions = {
                                    method: "PUT",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Accept: "application/json",
                                      Authorization: `Basic ${credentials}`,
                                    },
                                    body: JSON.stringify({ password }),
                                  };

                                  const response = await fetch(
                                    `${localApi}/register/updatePassword/byMobile/${mobile}`,
                                    requestOptions
                                  );
                                  const data = await response.json();

                                  if (data.message === "Data Updated Successfully !!!") {
                                    window.location.reload(false);
                                  }
                                }}
                              >
                                Update mPIN
                              </Button>
                            </CardBody>
                          )}
                        </form>
                      )}
                    </DialogContent>
                  </Card>
                </Dialog>
              </GridItem>
            ) : (
              ""
            )}
            <GridContainer>
              <GridItem md={6} sm={6}>
                <ImageGallery
                  showFullscreenButton={false}
                  showPlayButton={false}
                  startIndex={0}
                  showIndex={true}
                  // items={images.filter((item) => item.original !== "")}
                  items={imageGal}
                  showThumbnails={true}
                  renderLeftNav={(onClick, disabled) => {
                    return (
                      <button
                        className="image-gallery-left-nav"
                        disabled={disabled}
                        onClick={onClick}
                      />
                    );
                  }}
                  renderRightNav={(onClick, disabled) => {
                    return (
                      <button
                        className="image-gallery-right-nav"
                        disabled={disabled}
                        onClick={onClick}
                      />
                    );
                  }}
                />
              </GridItem>
              <GridItem md={6} sm={12} xs={12}>
                <GridContainer>
                  <GridItem md={12} sm={12} xs={12}>
                    <span className={classes.mainPrice}>
                      <strong>
                        Item Code: {item.itemCodeNumber + "-" + item.id}
                      </strong>
                      <strong>
                        {item && item.gstCash === true ? (
                          <>
                            <h5>
                              <span style={{ color: "red" }}>
                                Price: ₹ {convertToNextTenth(item && item.taxInclude)}
                                <span style={{ fontSize: "12px", marginLeft: "4px" }}>
                                  (Inclusive of GST)
                                </span>
                              </span>
                            </h5>
                          </>
                        ) : (
                          <>
                            <h5>
                              <span style={{ color: "black" }}>
                                ₹ {convertToNextTenth(item && item.cashPrice)}
                              </span>
                            </h5>
                          </>
                        )}
                      </strong>
                    </span>
                  </GridItem>
                </GridContainer>
                <h1 className={classes.mainPrice}>
                  {item?.prodDescription}
                </h1>
                <h5 className={classes.mainPrice}>
                  <span style={{ fontWeight: "bold" }}>Description:</span><br />
                  {cat.title +
                    " " +
                    catMM.title +
                    " " + child + " " +
                    (item.readyGram * sets.pcs).toFixed(4) +
                    " Average Gram of " +
                    sets.setDesc +
                    " and " +
                    box.boxDesc +
                    ", " +
                    item.ctnDescription}
                </h5>
                <h5 className={classes.mainPrice}>
                  <span style={{ fontWeight: "bold" }}>Moq:</span><br />
                  Minimum order quantity is {item.moq} Boxes. Each size should have a minimum of {totalPiece} boxes.
                </h5>
                <h5
                  style={{
                    backgroundColor: "black",
                    width: "30%",
                    textAlign: "center",
                    color: "white",
                  }}
                >
                  {proTotal === 1 ? "In Stock" : "Make To Order"}
                </h5>
                <Accordion
                  active={0}
                  activeColor="info"
                  collapses={[
                    {
                      title: "Size Charts",
                      content: (
                        <span>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <p style={{ margin: 0 }}>Click here for</p>

                                <Tooltip
                                  id="tooltip-top"
                                  title="Click Here for Size Chart"
                                  placement="top"
                                  classes={{ tooltip: classes.tooltip }}
                                >
                                  <a href="/indian-bangles-size-guide">Bangles Size Chart</a>
                                </Tooltip>
                              </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={checkedFullSize}
                                    onChange={(event) =>
                                      setCheckedFullSize(event.target.checked)
                                    }
                                    value="checkedFullSize"
                                    classes={{
                                      switchBase: classe.switchBase,
                                      checked: classe.switchChecked,
                                      thumb: classe.switchIcon,
                                      track: classe.switchBar,
                                    }}
                                  />
                                }
                                classes={{
                                  label: classe.label,
                                  root: classe.labelRoot,
                                }}
                                label={
                                  checkedFullSize === false ? (
                                    <span>Full Size Available</span>
                                  ) : (
                                    <span
                                      style={{
                                        color:
                                          checkedFullSize === true
                                            ? "#d81b60"
                                            : "",
                                      }}
                                    >
                                      Full Size Available
                                    </span>
                                  )
                                }
                              />
                            </GridItem>
                          </GridContainer>

                          {checkedFullSize === true ? (
                            <GridContainer>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x8"
                                  id="1x8"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x8,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x8(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x8("0");
                                      } else if (value === "") {
                                        setSize1x8("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x8(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                                <Popover
                                  classes={{
                                    paper: classPop.popover,
                                  }}
                                  open={Boolean(anchorElTop)}
                                  anchorEl={anchorElTop}
                                  onClose={() => setAnchorElTop(null)}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                  }}
                                >
                                  <div
                                    className={
                                      classPop.popoverBody +
                                      " " +
                                      classes.textCenter
                                    }
                                  >
                                    Quantity should be {totalPiece} or greater
                                    than {totalPiece} Boxes in Any Size.
                                  </div>
                                </Popover>
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x10"
                                  id="1x10"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x10,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x10(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x10("0");
                                      } else if (value === "") {
                                        setSize1x10("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x10(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x12"
                                  id="1x12"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x12,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x12(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x12("0");
                                      } else if (value === "") {
                                        setSize1x12("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x12(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x14"
                                  id="1x14"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x14,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x14(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x14("0");
                                      } else if (value === "") {
                                        setSize1x14("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x14(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x0"
                                  id="2x0"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x0,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x0(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x0("0");
                                      } else if (value === "") {
                                        setSize2x0("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x0(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x2"
                                  id="2x2"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x2,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x2(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x2("0");
                                      } else if (value === "") {
                                        setSize2x2("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x2(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x4"
                                  id="2x4"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x4,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x4(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x4("0");
                                      } else if (value === "") {
                                        setSize2x4("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x4(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x6"
                                  id="2x6"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x6,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x6(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x6("0");
                                      } else if (value === "") {
                                        setSize2x6("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x6(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x8"
                                  id="2x8"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x8,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x8(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x8("0");
                                      } else if (value === "") {
                                        setSize2x8("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x8(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="2x10"
                                  id="2x10"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x10,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x10(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x10("0");
                                      } else if (value === "") {
                                        setSize2x10("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x10(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="2x12"
                                  id="2x12"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x12,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x12(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x12("0");
                                      } else if (value === "") {
                                        setSize2x12("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x12(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="2x14"
                                  id="2x14"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x14,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x14(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x14("0");
                                      } else if (value === "") {
                                        setSize2x14("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x14(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="3x0"
                                  id="3x0"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size3x0,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize3x0(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize3x0("0");
                                      } else if (value === "") {
                                        setSize3x0("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize3x0(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          ) : (
                            ""
                          )}

                          <FormControlLabel
                            control={
                              <Switch
                                checked={checkedCutSize}
                                onChange={(event) =>
                                  setCheckedCutSize(event.target.checked)
                                }
                                value="checkedCutSize"
                                classes={{
                                  switchBase: classe.switchBase,
                                  checked: classe.switchChecked,
                                  thumb: classe.switchIcon,
                                  track: classe.switchBar,
                                }}
                              />
                            }
                            classes={{
                              label: classe.label,
                              root: classe.labelRoot,
                            }}
                            label={
                              checkedCutSize === false ? (
                                <span>
                                  Click here, If you have a requirement for Cut
                                  Size
                                </span>
                              ) : (
                                <span
                                  style={{
                                    color:
                                      checkedCutSize === true ? "#00acc1" : "",
                                  }}
                                >
                                  Click here, If you have a requirement for Cut
                                  Size
                                </span>
                              )
                            }
                          />

                          {checkedCutSize === true ? (
                            <GridContainer>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x9"
                                  id="1x9"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x9,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x9(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x9("0");
                                      } else if (value === "") {
                                        setSize1x9("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x9(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                                <Popover
                                  classes={{
                                    paper: classPop.popover,
                                  }}
                                  open={Boolean(anchorElTop)}
                                  anchorEl={anchorElTop}
                                  onClose={() => setAnchorElTop(null)}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                  }}
                                >
                                  <div
                                    className={
                                      classPop.popoverBody +
                                      " " +
                                      classes.textCenter
                                    }
                                  >
                                    Quantity should be {totalPiece} or greater
                                    than {totalPiece} Boxes in Any Size.
                                  </div>
                                </Popover>
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x11"
                                  id="1x11"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x11,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x11(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x11("0");
                                      } else if (value === "") {
                                        setSize1x11("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x11(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x13"
                                  id="1x13"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x13,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x13(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x13("0");
                                      } else if (value === "") {
                                        setSize1x13("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x13(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="1x15"
                                  id="1x15"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size1x15,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize1x15(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize1x15("0");
                                      } else if (value === "") {
                                        setSize1x15("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize1x15(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x1"
                                  id="2x1"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x1,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x1(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x1("0");
                                      } else if (value === "") {
                                        setSize2x1("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x1(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x3"
                                  id="2x3"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x3,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x3(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x3("0");
                                      } else if (value === "") {
                                        setSize2x3("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x3(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x5"
                                  id="2x5"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x5,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x5(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x5("0");
                                      } else if (value === "") {
                                        setSize2x5("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x5(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x7"
                                  id="2x7"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x7,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x7(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x7("0");
                                      } else if (value === "") {
                                        setSize2x7("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x7(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4} sm={4} md={4}>
                                <CustomInput
                                  labelText="2x9"
                                  id="2x9"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x9,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x9(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x9("0");
                                      } else if (value === "") {
                                        setSize2x9("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x9(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="2x11"
                                  id="2x11"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x11,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x11(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x11("0");
                                      } else if (value === "") {
                                        setSize2x11("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x11(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="2x13"
                                  id="2x13"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x13,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x13(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x13("0");
                                      } else if (value === "") {
                                        setSize2x13("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x13(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="2x15"
                                  id="2x15"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size2x15,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize2x15(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize2x15("0");
                                      } else if (value === "") {
                                        setSize2x15("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize2x15(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3} sm={3} md={3}>
                                <CustomInput
                                  labelText="3x1"
                                  id="3x1"
                                  number
                                  inputProps={{
                                    placeholder: totalPiece,
                                    value: size3x1,
                                    onChange: (e) => {
                                      const { value } = e.target;
                                      setSize3x1(value);
                                    },
                                    onBlur: (e) => {
                                      const { value } = e.target;
                                      if (value === "0") {
                                        setSize3x1("0");
                                      } else if (value === "") {
                                        setSize3x1("0");
                                      } else if (value < totalPiece) {
                                        setAnchorElTop(e.currentTarget);
                                        setSize3x1(totalPiece);
                                      }
                                    },
                                  }}
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          ) : (
                            ""
                          )}
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <div
                                style={{
                                  textAlign: "right",     // float right effect
                                  lineHeight: "20px"       // reduces space between lines
                                }}
                              >
                                {checkedFullSize && checkedCutSize ? <>
                                  <p style={{ color: "#999", margin: "2px 0" }}>
                                    Full Size Total: {indianQty} Units
                                  </p>
                                  <p style={{ color: "#999", margin: "2px 0" }}>
                                    Cut Size Total: {usQty} Units
                                  </p>
                                </> : checkedFullSize ?
                                  <p style={{ color: "#999", margin: "2px 0" }}>
                                    Full Size Total: {indianQty} Units
                                  </p> : checkedCutSize ? <p style={{ color: "#999", margin: "2px 0" }}>
                                    Cut Size Total: {usQty} Units
                                  </p> : null}
                                <p style={{ color: "red", margin: "2px 0" }}>
                                  Grand total: {indianQty + usQty}
                                </p>

                                <p style={{ color: "red", margin: "2px 0" }}>
                                  Order Value: ₹{" "}
                                  {item.gstCash === true
                                    ? (item.taxInclude * (indianQty + usQty)).toFixed(2)
                                    : (item.cashPrice * (indianQty + usQty)).toFixed(2)}
                                </p>
                              </div>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                              <p>
                                If you have any additional requirements or
                                changes for your order, please comment here.
                              </p>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Comment"
                                id="comment"
                                number
                                inputProps={{
                                  placeholder:
                                    "Mix different four sizes in one design, or mix different six designs in one size.",
                                  value: comment,
                                  multiline: true,
                                  rows: 5,
                                  onChange: (e) => setComment(e.target.value),
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </span>
                      ),
                    },
                    // {
                    //   title: "Product Details and Care",
                    //   content: (
                    //     <ul>
                    //       <li>
                    //         Durability only for a period of (6) months from the
                    //         date of sale(Not for spoilage or breakage invalid if
                    //         not stamped).
                    //       </li>
                    //       <li>
                    //         Please wash this piece with soap and warm water &
                    //         wipe it with soft cotton cloth for longer life.
                    //       </li>
                    //     </ul>
                    //   ),
                    // },
                  ]}
                />
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)", // 3 per row
                    gap: "20px",
                    textAlign: "center",
                    marginTop: "20px"
                  }}
                >
                  {/* 1 */}
                  <div>
                    <HistoryIcon style={{ fontSize: 60 }} onClick={(e) => setIsVisibleReturn(e.currentTarget)} />
                    <div>30 Days Returnable</div>
                  </div>
                  <Popover
                    classes={{
                      paper: classPop.popover,
                    }}
                    open={Boolean(isVisibleReturn)}
                    anchorEl={isVisibleReturn}
                    onClose={() => setIsVisibleReturn(null)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    <div
                      className={
                        classPop.popoverBody
                      }
                    >
                      <h1 style={{ fontSize: "18px", margin: 0 }}>30 Days Returnable:</h1>
                      <h4 style={{ fontSize: "15px", marginTop: "5px", fontWeight: "normal" }}>
                        Our policy lasts 30 days. If 30 days have passed since you received your purchase bill,
                        unfortunately we can’t offer you a refund.
                      </h4>
                    </div>
                  </Popover>

                  {/* 2 */}
                  <div>
                    <CurrencyExchangeIcon style={{ fontSize: 60 }} onClick={(e) => setIsVisibleRefund(e.currentTarget)} />
                    <div>Refund</div>
                  </div>
                  <Popover
                    classes={{
                      paper: classPop.popover,
                    }}
                    open={Boolean(isVisibleRefund)}
                    anchorEl={isVisibleRefund}
                    onClose={() => setIsVisibleRefund(null)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    <div
                      className={
                        classPop.popoverBody
                      }
                    >
                      <h1 style={{ fontSize: "18px", margin: 0 }}>Refund:</h1>
                      <h4 style={{ fontSize: "15px", marginTop: "5px", fontWeight: "normal" }}>
                        You are eligible for a full refund only after the returned goods are received within 30 days of purchase, in cases where the goods delivered are of a different quality, design, or size.
                      </h4>
                    </div>
                  </Popover>

                  {/* 3 */}
                  <div>
                    <RefreshIcon style={{ fontSize: 60 }} onClick={(e) => setIsVisibleExchange(e.currentTarget)} />
                    <div>Lifetime Exchange</div>
                  </div>
                  <Popover
                    classes={{
                      paper: classPop.popover,
                    }}
                    open={Boolean(isVisibleExchange)}
                    anchorEl={isVisibleExchange}
                    onClose={() => setIsVisibleExchange(null)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    <div
                      className={
                        classPop.popoverBody
                      }
                    >
                      <h1 style={{ fontSize: "18px", margin: 0 }}>Lifetime Exchange:</h1>
                      <h4 style={{ fontSize: "15px", marginTop: "5px", fontWeight: "normal" }}>
                        We offer a lifetime return policy on all purchases within India. The product, along with the bill, can be returned at its current market value. We will provide a new set of bangles in exchange for the returned products, with deductions applied for making charges and processing charges.
                      </h4>
                    </div>
                  </Popover>

                  {/* 4 */}
                  <div>
                    {/* <WorkspacePremiumIcon style={{ fontSize: 60 }} onClick={(e) => {
                      console.log("Certified");
                    }} />
                    <div>Certified etc</div> */}
                    <Link to="/license" style={{ textDecoration: "none", color: "inherit" }}>
                      <WorkspacePremiumIcon
                        style={{ fontSize: 60, cursor: "pointer" }}
                      />
                      <div>Certified etc</div>
                    </Link>
                  </div>

                  {/* 5 */}
                  <div>
                    <LocalShippingIcon style={{ fontSize: 60 }} onClick={(e) => setIsVisibleDelivery(e.currentTarget)} />
                    <div>30 Days Delivery</div>
                  </div>
                  <Popover
                    classes={{
                      paper: classPop.popover,
                    }}
                    open={Boolean(isVisibleDelivery)}
                    anchorEl={isVisibleDelivery}
                    onClose={() => setIsVisibleDelivery(null)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    <div
                      className={
                        classPop.popoverBody
                      }
                    >
                      <h1 style={{ fontSize: "18px", margin: 0 }}>30 Days Delivery:</h1>
                      <h4 style={{ fontSize: "15px", marginTop: "5px", fontWeight: "normal" }}>
                        Delivery within 30 working days across India.
                      </h4>
                    </div>
                  </Popover>

                  {/* 6 */}
                  <div>
                    <SupportAgentIcon style={{ fontSize: 60 }} onClick={(e) => setIsVisibleCustomer(e.currentTarget)} />
                    <div>Customer Care</div>
                  </div>
                  <Popover
                    classes={{
                      paper: classPop.popover,
                    }}
                    open={Boolean(isVisibleCustomer)}
                    anchorEl={isVisibleCustomer}
                    onClose={() => setIsVisibleCustomer(null)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    <div
                      className={
                        classPop.popoverBody
                      }
                    >
                      <h1 style={{ fontSize: "18px", margin: 0 }}>Customer Care:</h1>
                      <h4 style={{ fontSize: "15px", marginTop: "5px", fontWeight: "normal" }}>
                        For any inquiries, please contact us at<br /> 022-44512468 or +91 99674 27786. info@indianbangles.in
                      </h4>
                    </div>
                  </Popover>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px",
                    gap: "8px"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    style={{
                      width: "20px",        // bigger size
                      height: "20px",       // bigger size
                      accentColor: "black" // checkbox color (blue)
                    }} />
                  <span>I agree to the <a href="/terms-and-conditions">Terms & Conditions</a></span>
                </div>

                <div
                  style={{
                    border: "1px solid #ccc",
                    padding: "15px",
                    borderRadius: "8px",
                    marginTop: "20px",
                    maxWidth: "500px"
                  }}
                >
                  {/* Row: Icon + Label */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "8px"
                    }}
                  >
                    <ApartmentIcon style={{ fontSize: 28 }} />
                    <span style={{ fontWeight: "bold" }}>Office Address:</span>
                  </div>

                  {/* Address Text */}
                  <div style={{ marginLeft: "38px", lineHeight: "20px", color: "#555" }}>
                    Shop no.20, Ashmita Jyoti CHS D10/11 bldg,<br />
                    Charkop Naka, Marve Road,<br />
                    Malad West Mumbai-400095 - Maharashtra
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  {/* Left Button */}
                  <Button round color="rose">
                    MemberShip
                  </Button>

                  {/* Right Button */}
                  {item.moq === indianQty + usQty && termsAccepted || item.moq < indianQty + usQty && termsAccepted ? (
                    <Button round color="rose" onClick={handleAddCart}>
                      Add to Cart &nbsp; <ShoppingCart />
                    </Button>
                  ) : (
                    <Button round disabled>
                      Add to Cart &nbsp; <ShoppingCart />
                    </Button>
                  )}
                </div>

              </GridItem>
            </GridContainer>
          </div>
          {/* <div className={classNames(classes.features, classes.textCenter)}>
            <GridContainer>
              <GridItem md={3} sm={6}>
                <InfoArea
                  title="RETURN POLICY"
                  description="We offer a lifetime return policy on all purchases within India. The product along with the Bill can be returned on its current market value. We will give the fresh lot of bangles in return for the products with deductions towards making charges and processing charges."
                  icon={VerifiedUser}
                  iconColor="success"
                  vertical
                />
              </GridItem>
              <GridItem md={3} sm={6}>
                <InfoArea
                  title="POPULAR ITEMS"
                  description="Our 5MM and 8MM products are best sellers in India as well as foreign countries like  Bangladesh, USA, UAE and Iran. Some of our popular brands are Indian Bangles, Royal Arts Bangles, Madam Asmi and Evershine bangles is the most liked brand, and it is sold in almost every state of India."
                  icon={Favorite}
                  iconColor="rose"
                  vertical
                />
              </GridItem>
              <GridItem md={3} sm={6}>
                <InfoArea
                  title="REFUND POLICY"
                  description="You are liable to get the full refund only after the returns of goods within 30 days of purchase, in case of goods received of different quality, different design or different size."
                  icon={VerifiedUser}
                  iconColor="success"
                  vertical
                />
              </GridItem>
              <GridItem md={3} sm={6}>
                <InfoArea
                  title="DELEIVERY POLICY"
                  description="The order will be delivered within 25 working days in India from the date of payment and it will take a minimum 90 working days to be delivered outside India."
                  icon={LocalShipping}
                  iconColor="info"
                  vertical
                />
              </GridItem>
            </GridContainer>
          </div> */}
          <div className={classes.relatedProducts}>
            <h3 className={classNames(classes.title, classes.textCenter)}>
              You may also be interested in:
            </h3>
            <GridContainer>
              {prodList &&
                prodList.map((prod) => {
                  let resultChild = "";   // initialize empty string

                  prod.productchild.forEach((item) => {
                    let line = item.title.trim();

                    if (line.includes("Plating")) {
                      // Remove [ ] brackets
                      line = line.replace(/\[/g, "").replace(/\]/g, "").trim();

                      // Extract only text AFTER "Plating"
                      const afterPlating = line
                        .substring(line.indexOf("Plating") + "Plating".length)
                        .trim();

                      // Clean again
                      const cleanText = afterPlating
                        .replace(/\[/g, "")
                        .replace(/\]/g, "")
                        .trim();

                      // Add to final string
                      resultChild += cleanText + " ";
                    }
                  });
                  return (
                    <GridItem sm={6} md={3} key={prod.id}>
                      <Card product>
                        <CardHeader image>
                          <CornerRibbon
                            position={
                              prod.stockSize.length === 1
                                ? "top-left"
                                : "top-right"
                            } // position="top-right" // OPTIONAL, default as "top-right"
                            fontColor="#f0f0f0" // OPTIONAL, default as "#f0f0f0"
                            backgroundColor="black" // OPTIONAL, default as "#2c7"
                            containerStyle={{}} // OPTIONAL, style of the ribbon
                            style={{ fontSize: "13px", fontWeight: "bold" }} // OPTIONAL, style of ribbon content
                            className="" // OPTIONAL, css class of ribbon
                          >
                            {" "}
                            {prod.stockSize.length === 1
                              ? "In Stock"
                              : "Make To Order"}
                          </CornerRibbon>
                          <a
                            href={`/bangles-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}
                          // &Plating=${prod.plating.description.slice(8)}
                          >
                            {/* {prod.design1.img1active === 1 ? (
                            <img src={imgApi + "" + prod.design1.image1} alt="img1active" />
                          ) : prod.design2.img2active === 1 ? (
                            <img src={imgApi + "" + prod.design2.image2} alt="img2active" />
                          ) : prod.design3.img3active === 1 ? (
                            <img src={imgApi + "" + prod.design3.image3} alt="img3active" />
                          ) : prod.design4.img4active === 1 ? (
                            <img src={imgApi + "" + prod.design4.image4} alt="img4active" />
                          ) : prod.design5.img5active === 1 ? (
                            <img src={imgApi + "" + prod.design5.image5} alt="img5active" />
                          ) : prod.design6.img6active === 1 ? (
                            <img src={imgApi + "" + prod.design6.image6} alt="img6active" />
                          ) : (
                            ""
                          )} */}
                            <img src={prod.productimage[0].cpanelPath} alt="..." />
                            <p
                              style={{
                                position: "absolute",
                                top: "65%",
                                left: "50%",
                                width: "65px",
                                height: "65px",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <img src={logo} alt="logo1" />
                              {/* {imgApi + "" + prod.design1.image1 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo1" />
                            ) : imgApi + "" + prod.design2.image2 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo2" />
                            ) : imgApi + "" + prod.design3.image3 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo3" />
                            ) : imgApi + "" + prod.design4.image4 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo4" />
                            ) : imgApi + "" + prod.design5.image5 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo5" />
                            ) : imgApi + "" + prod.design6.image6 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo6" />
                            ) : (
                              ""
                            )} */}
                            </p>
                          </a>
                        </CardHeader>
                        <h6
                          className={classNames(
                            classes.cardCategory,
                            classes.textRose
                          )}
                        >
                          {prod.category.title + " " + prod.parent.title} <br />{" "}
                          {resultChild.trim()}-{prod.id}
                        </h6>
                      </Card>
                      <Card>
                        <CardBody>
                          <div className={classes.cardDescription}>
                            {(prod.readyGram * prod.sets.pcs).toFixed(4)} Avg Gram
                            Of {prod.sets.setDesc} {"and "}
                            {prod.box.boxDesc}
                            {","} {"(" + prod.packingMaterial.type + ")"}{","} {prod.box.brandName}{","} {prod.ctnDescription}
                            {"."}
                          </div>
                        </CardBody>
                        <CardFooter className={classes.justifyContentBetween}>
                          <div className={classes.price}>
                            {prod.gstCash === true ? (
                              <>
                                <h5>
                                  <span style={{ color: "red" }}>
                                    Price ₹{" "}
                                    {convertToNextTenth(prod.taxInclude / prod.box.box) +
                                      " Inc."}
                                  </span>
                                </h5>
                              </>
                            ) : (
                              <>
                                <h5>
                                  <span style={{ color: "black" }}>
                                    Price ₹{" "}
                                    {convertToNextTenth(prod.cashPrice / prod.box.box)}
                                  </span>
                                </h5>
                              </>
                            )}

                            {/* {!activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              prod.taxCalculation.cash_gst === 1 ? (
                                <>
                                  <h5>
                                    <span style={{ color: "red" }}>
                                      Price ₹{" "}
                                      {(
                                        prod.taxCalculation.taxincl /
                                        prod.box.box
                                      ).toFixed(2)}
                                      /-
                                    </span>
                                  </h5>{" "}
                                  <h6>
                                    <a href="/indian-login">Login</a> to see
                                    prices and exciting offers.
                                  </h6>{" "}
                                </>
                              ) : (
                                <h5>
                                  Price{" "}
                                  <span>
                                    ₹{" "}
                                    {(
                                      prod.taxCalculation.cash / prod.box.box
                                    ).toFixed(2)}
                                    /-*
                                  </span>
                                </h5>
                              )
                            ) : prod.taxCalculation.cash_gst === 1 ? (
                              <>
                                <h5>
                                  <span style={{ color: "#9c27b0" }}>
                                    Price ₹{" "}
                                    {(
                                      prod.taxCalculation.taxincl / prod.box.box
                                    ).toFixed(2)}
                                    /-
                                  </span>
                                </h5>{" "}
                                <h6>
                                  <a href="/indian-login">Login</a> to see
                                  prices and exciting offers.
                                </h6>
                              </>
                            ) : (
                              <h5>
                                Price{" "}
                                <span>
                                  ₹{" "}
                                  {(
                                    prod.taxCalculation.cash / prod.box.box
                                  ).toFixed(2)}
                                  /-*
                                </span>
                              </h5>
                            )
                          ) : (
                            ""
                          )}

                          {activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "red",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            ) : (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#9c27b0",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            )
                          ) : (
                            ""
                          )} */}
                          </div>
                          <div className={classes.stats}>
                            <Tooltip
                              id="tooltip-top"
                              title="Save to Wishlist"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <Button justIcon color="rose" simple>
                                <Favorite />
                              </Button>
                            </Tooltip>
                          </div>
                        </CardFooter>
                        <div style={{ textAlign: "center", marginBottom: "7px" }}>
                          <Button
                            color="rose"
                            href={`/indian-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}
                          // &Plating=${prod.plating.description.slice(8)}
                          >
                            Buy Now
                          </Button>
                        </div>
                        {/* <CardFooter className={classes.justifyContentBetween}>
                        <div style={{textAlign : "center", marginBottom: "7px"}}>
                          <Button
                            color="rose"
                            href={`/indian-product?id=${prod.id}&catdesc=${prod.productCategory.title}&cat1desc=${prod.productParent.title}`}
                            
                          >
                            Buy Now
                          </Button>
                        </div>
                        <div>
                          <Button
                            color="success"
                            round
                            justIcon
                            href={`https://api.whatsapp.com/send/?phone=${prod.user.whatsapp
                              }&text=https://indianbangles.in/indian-product?id=${prod.id
                              }%20${prod.banglessizemm.description
                              }%20${prod.plating.description.slice(
                                8
                              )}&app_absent=0`}
                          >
                            <i
                              className="fab fa-whatsapp"
                              style={{ fontSize: "30px" }}
                            />
                          </Button>
                        </div>
                      </CardFooter> */}
                      </Card>
                    </GridItem>
                  )
                })}
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
